var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leo-operator-assistant" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "Leo SOC助手",
            visible: _vm.drawerOpen,
            size: "420px",
            direction: "rtl",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerOpen = $event
            }
          }
        },
        [
          _c("p", { staticClass: "muted assistant-hint" }, [
            _vm._v(
              "\n      问后台操作、训练 SOP、何时找工程。已感知当前页面，会优先给本页相关说明。\n    "
            )
          ]),
          _vm._v(" "),
          _vm.pagePreface
            ? _c("p", { staticClass: "assistant-page-preface" }, [
                _vm._v(_vm._s(_vm.pagePreface))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.clarifyOptions.length
            ? _c(
                "div",
                { staticClass: "assistant-clarify" },
                [
                  _c("p", { staticClass: "assistant-clarify-prompt" }, [
                    _vm._v(_vm._s(_vm.clarifyPrompt))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.clarifyOptions, function(opt, idx) {
                    return _c(
                      "el-button",
                      {
                        key: idx,
                        attrs: { size: "mini", type: "primary", plain: "" },
                        on: {
                          click: function($event) {
                            return _vm.askClarifyOption(opt)
                          }
                        }
                      },
                      [_vm._v(_vm._s(opt.label))]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "assistant-topics" },
            _vm._l(_vm.quickTopics, function(t) {
              return _c(
                "el-button",
                {
                  key: t.id,
                  attrs: {
                    size: "mini",
                    plain: "",
                    loading: _vm.loading && _vm.question === t.question
                  },
                  on: {
                    click: function($event) {
                      return _vm.askQuick(t.question)
                    }
                  }
                },
                [_vm._v(_vm._s(t.labelZh))]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 3,
              placeholder: "输入问题，例如：Composer shadow 怎么办？"
            },
            model: {
              value: _vm.question,
              callback: function($$v) {
                _vm.question = $$v
              },
              expression: "question"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "assistant-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.loading
                  },
                  on: { click: _vm.ask }
                },
                [_vm._v("提问")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    size: "small",
                    plain: "",
                    disabled: !_vm.answer || _vm.loading
                  },
                  on: { click: _vm.onWrongAnswer }
                },
                [_vm._v("回答不对")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.answer
            ? _c("div", { staticClass: "assistant-answer" }, [
                _c("div", { staticClass: "assistant-answer-title" }, [
                  _vm._v("回答")
                ]),
                _vm._v(" "),
                _c("pre", { staticClass: "assistant-answer-body" }, [
                  _vm._v(_vm._s(_vm.answer))
                ]),
                _vm._v(" "),
                _vm.disclaimer
                  ? _c("p", { staticClass: "muted" }, [
                      _vm._v(_vm._s(_vm.disclaimer))
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-477408b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477408b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/LeoTrainingOperatorAssistant.vue
// module id = null
// module chunks = 